(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sidebar-mega-menu-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sidebar-mega-menu-init')) {
    class SidebarMegaMenuInit extends HTMLElement {
      connectedCallback() {
        const root = this.parentElement && this.parentElement.querySelector('[data-sidebar-mega-menu]');
        if (!root) return;
        if (root.dataset.bound) return;
        root.dataset.bound = 'true';

        const triggers = root.querySelectorAll('[data-sidebar-mega-menu-trigger]');
        triggers.forEach((trigger) => {
          const activate = () => {
            triggers.forEach((t) => t.classList.toggle('is-active', t === trigger));
            const targetId = trigger.dataset.panelTarget;
            root.querySelectorAll('[data-panel-id]').forEach((panel) => {
              panel.classList.toggle('is-active', panel.dataset.panelId === targetId);
            });
          };
          trigger.addEventListener('pointerenter', activate);
          trigger.addEventListener('focus', activate);
        });
      }
    }
    customElements.define('sidebar-mega-menu-init', SidebarMegaMenuInit);
  }
  } catch(e) { console.error(e); }
})();

})();
